import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

type Variant = 'label' | 'inline' | 'text';

interface SubscriberBadgeProps {
  variant?: Variant;
  label?: string;
  tooltip?: string;
  disabled?: boolean;
  sx?: object;
}

const defaultTooltip = 'サブスクリプション限定機能です';

const SubscriberBadge: React.FC<SubscriberBadgeProps> = ({
  variant = 'inline',
  label,
  tooltip = defaultTooltip,
  disabled = false,
  sx = {},
}) => {
  // label: InputLabel内に配置する用。テキスト + 小さいロックアイコン
  if (variant === 'label') {
    return (
      <Tooltip title={tooltip} arrow>
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4, ...sx }}>
          {label}
          <LockOutlinedIcon sx={{ fontSize: '1.2em', color: 'text.disabled' }} />
        </Box>
      </Tooltip>
    );
  }

  // text: 説明テキスト付き（フォーム下部等）
  if (variant === 'text') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ...sx }}>
        <LockOutlinedIcon sx={{ fontSize: '0.85rem', color: 'text.disabled' }} />
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {label ?? tooltip}
        </Typography>
      </Box>
    );
  }

  // inline: PRO バッジ + テキスト（カード内等）
  const disabledOpacity = disabled ? 0.5 : 1;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, opacity: disabledOpacity, ...sx }}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.3,
          px: 0.6,
          py: 0.1,
          borderRadius: 0.5,
          bgcolor: 'rgba(255, 215, 0, 0.15)',
          border: '1px solid rgba(255, 215, 0, 0.3)',
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: '0.75rem', color: 'rgb(255, 215, 0)' }} />
        <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: 700, color: 'rgb(255, 215, 0)', lineHeight: 1, letterSpacing: '0.05em' }}>
          PRO
        </Typography>
      </Box>
      {label && (
        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default SubscriberBadge;
